// extracted by mini-css-extract-plugin
export default {"tree":"Map_tree__S4vgG","selected-page":"Map_selected-page__8x4b4"};